"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTeamsAsync = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.fetchTeamsAsync = (0, typesafe_actions_1.createAsyncAction)(constants_1.FETCH_TEAMS_REQUEST, constants_1.FETCH_TEAMS_SUCCESS, constants_1.FETCH_TEAMS_FAILED, constants_1.FETCH_TEAMS_CANCEL)();